<template>
    <div class="search-container wf-component wf-search">
        <div class="wf-search-container flex flex-col">
            <div class="wf-search-input-container" v-show="showOutputField">
                <WFIcon name="search"/>
                <input id="wf-search-input" ref='searchInput' oncontextmenu="return false" placeholder="Insert at least 2 characters" data-translation-attributes="placeholder" data-translation-attribute-placeholder="search-placeholder"/>
                <div class="icon close" @click="clear($event)" v-show="results.length > 0"><WFIcon name="close"/></div>
            </div>
            <div class="wf-search-results" :class='{"wf-no-results": results.length == 0}'>
                <WFScrollableArea>
                    <transition-group name="list" tag="ul" class="wf-list">
                        <li class="wf-list-item" :class='{"wf-active": currentPOI && poiitem.id == currentPOI.id}' v-for="poiitem in results" :key='poiitem.id'>
                            <div class="list-poi">
                                <div class="list-poi-left">
                                    <label class="poi-name" v-html="poiitem.getName(language)"></label>
                                </div>
                                <div class="list-poi-right">
                                    <button class="btn poi-floor" v-if="poiitem.getFloor()"><label>{{translate('floor', [poiitem.getFloor().getName(language)])}}</label></button>
                                    <button class="btn btn-border" @click="onPOIClick(poiitem)"><WFIcon name="info"/><WFTranslate k="info">Info</WFTranslate></button>
                                    <button class="btn btn-active" @click="showPath(poiitem)"><WFIcon name="path"/><WFTranslate k="show_path">Näita teekonda</WFTranslate></button>
                                </div>
                            </div>
                        </li>
                    </transition-group>
                </WFScrollableArea>
                <span class="wf-search-no-results-text" v-show="results.length == 0" data-translation-element="search-no-result-text"></span>
            </div>
           
            <div id="wf-keyboard-container" class="wf-keyboard">
            </div>
        </div>
    </div>
</template>
<script>
import OSK from 'on-screen-js-keyboard';
import { WFTranslate, WFScrollableArea } from '@3dwayfinder/wayfinder-vue-components'

import { mapState } from 'vuex';

export default {
    components: {
		WFTranslate,
        WFScrollableArea
    },
    computed: {//yahLogo
		...mapState('wf', ['language', 'landscape', 'portrait', 'reset']),
	},
    props: {
        showOutputField: {
            type: Boolean,
            default: true
        },
        currentPOI: {
			type: Object,
			default: null
		}
    },
    data () {
		return {
			results: [],
			poi: {},
			keyboard: false,
            limit: 8
		}
	},
    watch: {
		searchVisible (current) {
			if (current && this.$refs.searchInput) {
				this.$refs.searchInput.focus();
			}
		},
		reset () {
			this.resetValues();
		},
		language (lang) {
			if (this.keyboard) {
				this.keyboard.changeLayout(lang);
			}
		}
	},
    mounted () {
		this.keyboard = new OSK('wf-search-input', 'wf-keyboard-container');
		this.keyboard.on('change', (keyword) => {
			let results = this.$wayfinder.search.search(keyword);
            results.filter(p => {
                return p.getShowInMenu()
            });

			if (this.limit > 0) {
				results = results.slice(0, this.limit);
			}

			this.results = Object.freeze(Object.values(results));
			if (keyword.length > 1) {
				if (Object.values(this.results).length > 0) {
					this.$wayfinder.statistics.onSearch(keyword, "successful");
				}
				else {
					this.$wayfinder.statistics.onSearch(keyword, "unsuccessful");
				}
			}
		});

        this.keyboard.addLayout("et", {
            'name': "Estonian",
            'local_name': "Eesti",
            'lang': "et",
            'keys': {
                "default": [
                    ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\u00FC", "\u00F5"],
                    ["a", "s", "d", "f", "g", "h", "j", "k", "l", "\u00F6", "\u00E4"],
                    ["z", "x", "c", "v", "b", "n", "m", ".", "&", {'key': "&#171;", 'action': ["backspace"], cls: "delete"}],
                    [{"key": " ", "cls": "key_spacebar"}]
                    ]
            }
        });

        this.keyboard.addLayout("fi", {
            'name': "Finnish",
            'local_name': "Suomi",
            'lang': "fi",
            'keys': {
                "default": [
                    ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\u00E5"],
                    ["a", "s", "d", "f", "g", "h", "j", "k", "l", "\u00F6", "\u00E4"],
                    ["z", "x", "c", "v", "b", "n", "m", ".", "&", {'key': "DEL", 'action': ["backspace"], cls: "delete"}],
                    [{"key": " ", "cls": "key_spacebar"}]
                    ]
            }
        });

        this.keyboard.addLayout('en', {
            "name": "English",
            "keyboard":"US International",
            "local_name": "English",
            "lang": "en",
            "keys": {
                "default": [
                    ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
                    ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
                    ["z", "x", "c", "v", "b", "n", "m", ".", "&", {'key': "DEL", 'action': ["backspace"], cls: "delete"}],
                    [{"key": " ", "cls": "key_spacebar"}]
                ]
            }
        });

		this.keyboard.changeLayout("et");
        this.$nextTick(() => {
            this.keyboard.setOutput("wf-search-input")
        })
	},
    methods: {
        close () {
            this.resetValues();
            this.$emit('close');
        },
        clear () {
            this.resetValues();
        },
        onPOIClick (poi) {
            this.$emit('onPOIClick', poi);
        },
        showPath (poi) {
            this.$emit('showPath', poi);
        },
        resetValues () {
			this.results = [];
			if (this.keyboard) {
				this.keyboard.changeLayout(this.language);
				this.keyboard.clearValue();
			}

			if (this.$refs.searchInput)
				this.$refs.searchInput.value = '';
		},
        setOutput (output) {
            console.log('search.setOutput', output);
			this.keyboard.setOutput(output);
		},
        translate (key, params) {
			return this.$wayfinder.translator.get(key, params)
		}
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    .search-container {
        width: 100%;
        height: 100%;
        
        .icon-close {
            position: relative;
        }
    }

    .poi-floor {
        font-size: 1.2rem !important;
        font-weight: 400 !important;
    }

    .wf-search-container {
        height: 100%;
        width: 60rem;
        margin: auto;
        padding: 0 !important;
        padding-bottom: 6rem !important;
        padding-top: 2rem !important;
    }

    .wf-search-input-container {
        
        position: relative;
        input {
            padding-left: 7rem;
            padding-right: 7rem;
            outline: transparent;
            background-color: #F2F2F2;
            width: 100%;
            height: 4.8rem;
            border: none;
            text-align: center;
        }
        & > .wf-icon, .icon {
            position: absolute;
            height: 2.4rem;
            width: 2.4rem;
        }

        .wf-icon-search {
            left: 1.2rem;
            --icon_color: @primary-color;
            top: 1.2rem;
            fill: @primary-color;
        }
    }

    .icon.close {
        display: flex;
        justify-content: center;
        align-items: center;
        right: 1.2rem;
        top: 1rem;
        background-color: @primary-color;
        // border: 0.1rem solid #E0DFDF;
        border-radius: 50%;
        width: 3rem;
        height: 3rem;
        z-index: 1;

        & > .wf-icon-close {
            height: 1.6rem;
            width: 1.6rem;
            margin-top: 0.2rem;
        }
    }

    .wf-search-results {
        padding: 1.6rem 0;
        height: 26rem !important;
        overflow: hidden;

        .wf-list-item {
            display: block;
            margin-bottom: 0.35rem;
        }

        ul {
            margin: 0;
            padding: 0;
        }
        .list-poi {
            list-style-type: none;
            font-weight: 700;
            display: flex;
            justify-content: space-between;
            border: @border-thickness solid #333;
            border-radius: @border-radius;
            padding: 0.4rem;
            align-items: center;
            font-size: 1.6rem;
            
            .list-poi-left {
                padding-left: 1.2rem;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .list-poi-right {
                display: flex;

                .btn-border {
                    margin-right: 0.4rem;
                }

                .btn-active .icon {
                    --color_icon: white;
                }
            }
        }
        
    }

    .wf-search-results .sa-content-longer ul {
        padding-right: 1.5rem;
    }

    .icon-info {
        --icon_color: @primary-color;
    }
    .wf-search-no-results-text {
        height: 100%;
        width: 100%;
        display: inline-block;
        vertical-align: middle;
        margin: auto;
        margin-top: 17%;
        color: rgba(167, 169, 172, 1);
        flex-grow: 1;
        font-size: 1.6rem;
        vertical-align: middle;
        text-align: center;
    }

    .keyboard-row {
        margin: auto;
        display: flex;
        justify-content: center;
    }

    .keyboard-key2x {
        width: 9.6rem !important;
    }

    .keyboard-key3x {
        width: 14.4rem !important;
    }

    .keyboard-key {
        border: @border-thickness solid @border-color;
        font-size: 2rem;
        text-transform: uppercase;
        line-height: 5rem !important;
        margin: 0.3rem;
        text-align: center;
        width: 5.5rem;
        height: 5rem;
        font-weight: 700;
        border-radius: @border-radius;
        transition: background-color @animation-speed;

        &:active {
            background-color: lighten(@primary-color, 60%) !important;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 25%);
        }

        &.keyboard-key_spacebar {
            width: 52rem !important;
            background-repeat: no-repeat;
            background-position: 50%;
            background-size: 1.6rem auto;
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAALCAYAAABhwJ3wAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TS0WrDnYQ6ZChOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi6OSk6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGX9GLfoQQQERmljEnSUl0HF/38PH1LsazOp/7c/SpOYsBPpF4lhmmTbxBPL1pG5z3icOsKKvE58RjJl2Q+JHrisdvnAsuCzwzbKZT88RhYrHQxkobs6KpEU8RR1VNp3wh47HKeYuzVq6y5j35C0M5fWWZ6zQjSGARS5AgQkEVJZRhI0arToqFFO3HO/iHXb9ELoVcJTByLKACDbLrB/+D391a+ckJLykUBwIvjvMxAgR3gUbNcb6PHadxAvifgSu95a/UgZlP0mstLXoEDGwDF9ctTdkDLneAoSdDNmVX8tMU8nng/Yy+KQsM3gI9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O7u9t7+PdPs7wceQXKFArLTcgAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+YLDgwFLap0RUkAAABJSURBVDjL7c+xDYAwDEXBMzAUDWOwCCumYShQKIgQCzhVXvXl5uRA8bbJqUCgtkMkQRUmnRrQgL6W394zocCFOfmhO3BgTYbOB3q4B5pDzsirAAAAAElFTkSuQmCC)	}
    }

    .landscape-top-banner {
        height: 36rem;
        flex-shrink: 0;
        flex-grow: 0;
        flex-basis: 36rem;
    }
</style>